export const API_URL  = "https://admin.thescript.co.za/assets/";
export const SMALLER_PROCESS = "https://cjmarketing.co/image_directory/loading.gif";
export const ACCESSCODE = "75re85345";
